import { Alert, Snackbar } from "@mui/material";
import * as React from "react";
import { TLCEventManager } from "../events/EventManager";

/**
 * @deprecated const { showToast } = useToast(); showToast("message", "success") instead
 */
export const SuccessMessageEvent = "SuccessMessageEvent";
export interface SuccessMessageEventData {
  message: string;
}

export const SuccessMessage: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const guid = TLCEventManager.addListener(
      SuccessMessageEvent,
      ({ message }: SuccessMessageEventData) => {
        setSuccessMessage(message);
        setOpen(true);
      }
    );

    return () => {
      TLCEventManager.removeListener(SuccessMessageEvent, guid);
    };
  }, []);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      onClose={handleClose}
      autoHideDuration={5000}
    >
      <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
        {successMessage}
      </Alert>
    </Snackbar>
  );
};
